module.exports = __webpack_public_path__ + "static/media/Isgmuseum-2-min.25ad906c.jpg";